import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import clsx from 'clsx';
const Modal = ({ title, children, open, onClose, id = 'modal', ariaLabel, className }) => {
    // Reference to the modal container for focus management
    const modalRef = useRef(null);
    const previouslyFocusedElement = useRef(null);
    // Generate unique IDs for ARIA relationships
    const titleId = `${id}-title`;
    const contentId = `${id}-content`;
    const handleCloseModal = (e) => {
        e.preventDefault();
        if (e.target === e.currentTarget) {
            onClose();
        }
    };
    // Handle escape key to close modal
    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.preventDefault();
            onClose();
        }
    };
    // Manage body scroll lock and focus handling
    useEffect(() => {
        if (open) {
            // Save the currently focused element to restore focus later
            previouslyFocusedElement.current = document.activeElement;
            // Lock scroll
            jQuery('html').addClass('scroll-locked');
            // Set focus to the modal container
            setTimeout(() => {
                if (modalRef.current) {
                    modalRef.current.focus();
                }
            }, 50);
        }
        else {
            // Restore scroll
            jQuery('html').removeClass('scroll-locked');
            // Restore focus to the previously focused element
            if (previouslyFocusedElement.current) {
                previouslyFocusedElement.current.focus();
            }
        }
    }, [open]);
    // Focus trap inside the modal
    useEffect(() => {
        if (!open)
            return;
        const handleTabKey = (e) => {
            if (e.key !== 'Tab' || !modalRef.current)
                return;
            // Find all focusable elements within the modal
            const focusableElements = modalRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];
            // If shift+tab and on first element, move to last element
            if (e.shiftKey && document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
            }
            // If tab and on last element, move to first element
            else if (!e.shiftKey && document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
            }
        };
        document.addEventListener('keydown', handleTabKey);
        return () => {
            document.removeEventListener('keydown', handleTabKey);
        };
    }, [open]);
    // Don't render if not open
    if (!open)
        return null;
    return ReactDOM.createPortal(_jsx("div", Object.assign({ className: clsx('modal-window', {
            open,
        }, className), onClick: handleCloseModal, onKeyDown: handleKeyDown, role: 'dialog', "aria-modal": 'true', "aria-labelledby": titleId, "aria-describedby": contentId, "aria-label": ariaLabel || undefined }, { children: _jsx("div", Object.assign({ className: 'modal-wrapper', ref: modalRef, tabIndex: -1 }, { children: _jsxs("div", Object.assign({ className: 'modal-container' }, { children: [_jsx("button", Object.assign({ className: 'modal-close', onClick: onClose, "aria-label": 'Close modal', type: 'button' }, { children: _jsx("span", Object.assign({ className: 'material-icons', "aria-hidden": 'true' }, { children: "close" })) })), _jsx("div", Object.assign({ className: 'modal-title', id: titleId }, { children: title })), _jsx("div", Object.assign({ className: 'modal-content', id: contentId }, { children: children }))] })) })) })), document.getElementById('sb-react-portal'));
};
export default Modal;
